import React, { useCallback } from 'react';
import type { CouponListParams, CouponSectionProps, CouponSectionType } from './coupon-section.types';
import { DEFAULT_COLLAPSED_ITEM_COUNT } from '../coupon.constants';
import { FlatList } from '../../../molecules/flat-list';
import { CouponList } from '../coupon-list';
import styles from './coupon-section.module.css';

export const CouponSection: React.FC<CouponSectionProps> = ({
    coupons,
    selectedCoupon,
    onSelectCoupon,
    onCouponDetail,
    collapsible = true,
    collapsedItemCount = DEFAULT_COLLAPSED_ITEM_COUNT,
    defaultExpanded = false,
    viewMoreText = 'Xem thêm',
    collapseText = 'Thu gọn',
    emptyText,
}) => {
    const renderSectionItem = useCallback(
        ({ item }: CouponListParams) => {
            if (!item?.data?.length) {
                return null;
            }
            return (
                <CouponList
                    section={item}
                    coupons={coupons}
                    collapsedItemCount={collapsedItemCount}
                    onSelectCoupon={onSelectCoupon}
                    onCouponDetail={onCouponDetail}
                    collapsible={collapsible}
                    defaultExpanded={defaultExpanded}
                    selectedCoupon={selectedCoupon}
                    viewMoreText={viewMoreText}
                    collapseText={collapseText}
                    emptyText={emptyText}
                />
            );
        },
        [
            emptyText,
            coupons,
            collapsible,
            collapsedItemCount,
            defaultExpanded,
            onCouponDetail,
            collapseText,
            viewMoreText,
            selectedCoupon,
            onSelectCoupon,
        ]
    );

    const renderEmptyComponent = useCallback(() => {
        return null;
    }, []);

    const keyExtractor = useCallback((item: CouponSectionType, index: number) => `${item.title}-section-${index}`, []);

    return (
        <FlatList
            className={styles.flatList}
            contentContainerClassName={styles.contentContainer}
            data={coupons}
            renderItem={renderSectionItem}
            keyExtractor={keyExtractor}
            showsVerticalScrollIndicator={false}
            ListEmptyComponent={renderEmptyComponent}
        />
    );
};
